import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';

const StyledMenu = styled.nav`
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.05);
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 3;

  & > ul {
    list-style: none;
    align-items: center;
    background: #fff;
    bottom: 0;
    display: flex;
    justify-content: space-evenly;
    height: 100%;
    padding: 0;
    margin: 0 auto;
    max-width: 1600px;
    position: relative;
    width: 100%;

    @media (min-width: 1024px) {
      width: 80%;
    }

    & li {
      width: 25%;
      height: 100%;
      border-top: 2px solid transparent;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
      button{
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        @media (min-width: 640px) {
          -webkit-justify-content: flex-start;
          -ms-flex-pack: start;
          justify-content: flex-start;
        }
        i {
          width: 32px;
          height: 32px;
          svg,
          svg g {
            -webkit-transition: all .3s ease-in-out;
            -moz-transition: all .3s ease-in-out;
            -o-transition: all .3s ease-in-out;
            transition: all .3s ease-in-out;
          }
        }
        span {
          display: none;
          @media (min-width: 640px) {
            display: inline-block;
          }
        }
      }
    }

    & li:hover,
    & li.active {
      border-top: 2px solid ${props => props.theme ? props.theme.blueBright : "#ccc"};
      i {
        svg,
        svg g {
          stroke: ${props => props.theme ? props.theme.blueBright : "#ccc"};
        }
      }
    }
  }
`;

Menu.defaultProps = {
  data: [
    {label: "List", value: "list", icon: "tab-list"},
    {label: "Tiles", value: "tiles", icon: "tab-tiles"},
    {label: "Radar Chart", value: "radar", icon: "tab-radar"},
    {label: "Matrix", value: "scatter", icon: "tab-scatter"}
  ]
};

Menu.propTypes = {
  data: PropTypes.array.isRequired,
  setView: PropTypes.func.isRequired,
  view: PropTypes.string,
};

export default function Menu (props) {
  const {data, setView, view} = props;
  return (
    <StyledMenu>
      <ul>
      {data.map((item, index) =>
        <li key={index} className={view === item.value ? "active" : null}>
          <Button fit white icon={item.icon} label={item.label} onClick={() => setView(item.value)}/>
        </li>
      )}
      </ul>
    </StyledMenu>
  )
}
